import { Component, OnInit } from '@angular/core';
import { StageService } from '../services/stage-modal.service';
import { QResult, QueovalDate } from '../../../../models';
import { CoreService, HttpService } from '../../../../services';
import { ColorReturn, TestStage } from '../../../../models/formation/formation.model';


@Component({
  selector: 'queoval-stage-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.css']
})

/*
* Composant pour l'affichage des test (BPF)
*/
export class TestComponent implements OnInit {

  // #region CONSTRUCTEUR

  constructor(
    public service: StageService,
    private http: HttpService,
    private indParam: CoreService
  ) { }

  // #endregion

  // #region VARIABLES GLOBALES
  /** initialise les valeurs des calendriers*/
  //public datePickerDebutInit: QueovalDate = new QueovalDate(new Date().getFullYear().toString(), (new Date().getMonth() + 1).toString(), '1');
  //public datePickerFinInit: QueovalDate = new QueovalDate(new Date().getFullYear().toString(), (new Date().getMonth() + 1).toString(), new Date().getDate().toString());
  /** liste des tests retourné à l'init */
  public lstTest: Array<TestStage> = [];
  public isCloturable: boolean = false;
  // #endregion

  // #region CYCLE DE VIE

  public ngOnInit(): void {
    this.lstTest = [];
    this.InitData();
    
  }
  /**
   *  ouvre une page qui contient le bilan pédagogique et financier (BPF)
   * */
  public openPageBilan() {
    open(`${this.indParam.AppParams.appUrl}Formation/PageBilan.aspx?IdStage= ${this.service.Stage.Ident}`);
  }

  /**
   *  ouvre une page qui contient l'aide pour le bilan pédagogique et financier (BPF)
   * */
  public downloadBilan() {
    open(`${this.indParam.AppParams.appUrl}Nosecu/AideBPF_V2.pdf`);
  }

  public clotureStage() {
    this.http.getHttp<QResult<boolean>>(`${this.indParam.AppParams.apiUrl}api/Stage/Vue360/CLOSE_STAGE/${this.service.Stage.Ident}`)
      .subscribe((result: QResult<boolean>) => {
        console.log('Stage cloturé')
      });
  }

  // #endregion

  // #region FONCTIONS PUBLIQUES
  /**
   * TODO : recharge le bilan avec les dates choisit
   * */
  public refresh() {

  }
  // #endregion

  // #region FONCTIONS PRIVES

  /**
   *  charge la liste des test à afficher en fonction du stage selectionné
   * */
  private InitData() {
    this.indParam.showSplash(true);
    this.http.getHttp<QResult<Array<TestStage>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Test/TEST_STAGE/${this.service.Stage.Ident}`)
      .subscribe((result: QResult<Array<TestStage>>) => {
        if (!result.HasError) {
          this.lstTest = result.Value;
          const redTest: TestStage[] = this.lstTest.filter((test: TestStage) => test.EtatRov == ColorReturn.RED);
          this.isCloturable = redTest.length == 0 && !this.service.Stage.Cloture;
        }
        this.indParam.showSplash(false);
      });
  }
  // #endregion
}
